import { render } from "./ModalConfirmacion.vue?vue&type=template&id=64990b59&scoped=true"
import script from "./ModalConfirmacion.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacion.vue?vue&type=script&lang=js"

import "./ModalConfirmacion.vue?vue&type=style&index=0&id=64990b59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64990b59"]])

export default __exports__